import React, { ChangeEvent, ReactElement, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Library } from "../library/Library";
import { LibrarySelect } from "../library/LibrarySelect";
import { Bundle } from "./Bundle";
import { BundleService } from "./BundleService";

interface IParams {
	onCreate: (bundle: Bundle) => void;
}

export const BundleForm = (props: IParams): ReactElement => {
	const [bundle] = useState<Bundle>(new Bundle());
	const [submitting, setSubmitting] = useState(false);
	const nameRef = useRef<HTMLInputElement>(null);
	const bundleService = new BundleService();

	const handleSubmit = async () => {
		if (!bundle.name.trim()) {
			nameRef.current?.focus();
			return;
		}
		setSubmitting(true);
		const bun = await bundleService.create(bundle);
		setSubmitting(false);
		props.onCreate(bun);
	};

	return (
		<>
			<h5 className="mb-3" style={{ fontWeight: 600 }}>
				<i className="fa fa-plus-circle" style={{ marginRight: 8, opacity: 0.6 }} />
				New Bundle
			</h5>
			<Form>
				<Row>
					<Col md={4}>
						<Form.Group>
							<Form.Label>Name</Form.Label>
							<Form.Control
								ref={nameRef}
								type="text"
								placeholder="e.g. Leadership Bundle"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									bundle.name = event.target.value;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={2}>
						<Form.Group>
							<Form.Label>Code</Form.Label>
							<Form.Control
								type="text"
								placeholder="e.g. LB01"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									bundle.code = event.target.value;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={4}>
						<Form.Group>
							<Form.Label>Libraries</Form.Label>
							<LibrarySelect
								defaultValue={bundle.libraries.map(
									(library: Library) => {
										return {
											value: library.id,
											label: library.name,
										};
									},
								)}
								handleChange={_selected => {
									bundle.libraries = _selected;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={2} className="d-flex align-items-end">
						<Form.Group className="w-100">
							<Button
								onClick={handleSubmit}
								disabled={submitting}
								className="w-100"
							>
								{submitting ? (
									<>
										<i className="fa fa-spinner fa-spin" /> Creating...
									</>
								) : (
									"Create"
								)}
							</Button>
						</Form.Group>
					</Col>
				</Row>
			</Form>
		</>
	);
};
